export const IGetConfigurationUseCaseType = Symbol('IGetConfigurationUseCase');
